import Uniforms from "./color_wipe_uniforms.glsl";
import Fragment from "./color_wipe_fragment.glsl";
import Vertex from "./color_wipe_vertex.glsl";
import * as THREE from "three";

export default (shader, color) => {
  shader.uniforms.wipePosition = { value: 0.0 };
  shader.uniforms.wipeColor = { value: new THREE.Color(color.color) };
  shader.uniforms.wipeMetalness = { value: color.metalness };
  shader.fragmentShader = Uniforms + shader.fragmentShader;
  shader.fragmentShader = shader.fragmentShader.replace("vec4 diffuseColor = vec4( diffuse, opacity );", Fragment).replace(
    "#include <metalnessmap_fragment>",
    `
    #include <metalnessmap_fragment>
    metalnessFactor = mix(metalnessFactor, wipeMetalness, t);
    `
  );
  shader.vertexShader = Uniforms + shader.vertexShader.replace("#include <begin_vertex>", Vertex);
};
